import React, {ReactElement} from 'react'
import Head from 'next/head'
import NextNProgress from 'nextjs-progressbar'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import {useQuery} from 'react-query'
import GetFeaturedCategories from '@/services/api/products/GetFeaturedCategories'
import {GetSettings} from '@/services/api/settings'
import GetAllCategories from '@/services/api/products/GetAllCategories'
import FloatingCartButton from '@/components/Cart/FloatingCartButton'
import WhatsappButton from './WhatsappButton'
import useUserPreferences from '@/hooks/useUserPreferences'
import { track } from '@/lib/tracker'
import { useRouter } from 'next/router'
export default function Layout({children}: {children: ReactElement}) {
  const {data} = useQuery(['featured_categories'], GetFeaturedCategories)
  const preferences = useUserPreferences()
  const { data: settings, isLoading, error } = useQuery(
    ['settings', preferences?.countryCode, preferences?.currencyCode],
    () => GetSettings(preferences?.countryCode, preferences?.currencyCode)
  )
  const {data: categories} = useQuery(['categories'], GetAllCategories)
  const router = useRouter();

  React.useEffect(() => {
    const handleRouteChange = (url: string) => {
      track({
        event_name: "page_view"
      });
    };

    // Track first load
    handleRouteChange(router.asPath);

    // Track route changes
    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);
  return (
    <>
      <Head>
        <meta name="description" content="Basmti" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <NextNProgress color="#00214D" />
      <Header
        featured_categories={data}
        settings={settings}
        categories={categories}
      />
      <FloatingCartButton />
      <WhatsappButton/>
      <div id="page-scroll">
        {children}
      </div>
      {settings && <Footer featured_categories={data} settings={settings} />}
    </>
  )
}
